// Mock data for HRFlo — frontend-only phase.
// All records are org-scoped in shape (organization_id) so backend swap is seamless.

export const ORG_ID = "org_demo_hrflo";

export const seedOrganization = {
  id: ORG_ID,
  name: "Kgalagadi Trading Co.",
  country: "Botswana",
  plan: "Growth",
  created_at: "2024-01-15",
};

export const seedUser = {
  id: "user_admin_1",
  organization_id: ORG_ID,
  name: "Onkarabile Dintwe",
  email: "onkarabile@kgalagadi.co.bw",
  role: "Org Admin",
  avatar:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces",
};

// Botswana Employment & Labour Relations — Schedule 4 (reg 22/23) records spine
export const seedEmployees = [
  {
    id: "emp_1",
    organization_id: ORG_ID,
    employee_number: "KTC-001",
    first_name: "Kabelo",
    last_name: "Morake",
    sex: "Male",
    date_of_birth: "1990-05-22",
    marital_status: "Married",
    national_id: "419051822",
    address: "Plot 2345, Extension 12, Gaborone",
    phone: "+267 71 234 567",
    email: "kabelo.morake@kgalagadi.co.bw",
    next_of_kin_name: "Neo Morake",
    next_of_kin_address: "Plot 2345, Extension 12, Gaborone",
    next_of_kin_relationship: "Spouse",
    department: "Operations",
    job_title: "Operations Supervisor",
    nature_of_employment: "Permanent",
    employment_type: "Full-time",
    commencement_date: "2019-03-01",
    probation_end_date: "2019-06-01",
    notice_period: "1 month",
    wage_rate: 9800,
    pay_interval: "Monthly",
    wage_components: "Basic P8,000; Transport allowance P800; Housing allowance P1,000",
    annual_leave_entitlement: 15,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Sunday",
    daily_hours: 8,
    weekly_hours: 40,
    night_work: false,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=200&h=200&fit=crop&crop=faces",
  },
  {
    id: "emp_2",
    organization_id: ORG_ID,
    employee_number: "KTC-002",
    first_name: "Tshepiso",
    last_name: "Sentle",
    sex: "Female",
    date_of_birth: "1994-05-24",
    marital_status: "Single",
    national_id: "294052411",
    address: "Plot 118, Block 6, Gaborone",
    phone: "+267 72 887 221",
    email: "tshepiso.sentle@kgalagadi.co.bw",
    next_of_kin_name: "Mpho Sentle",
    next_of_kin_address: "Molepolole",
    next_of_kin_relationship: "Mother",
    department: "Finance",
    job_title: "Accountant",
    nature_of_employment: "Permanent",
    employment_type: "Full-time",
    commencement_date: "2021-07-12",
    probation_end_date: "2021-10-12",
    notice_period: "1 month",
    wage_rate: 12500,
    pay_interval: "Monthly",
    wage_components: "Basic P11,000; Transport allowance P1,500",
    annual_leave_entitlement: 15,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Sunday",
    daily_hours: 8,
    weekly_hours: 40,
    night_work: false,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop&crop=faces",
  },
  {
    id: "emp_3",
    organization_id: ORG_ID,
    employee_number: "KTC-003",
    first_name: "Boitumelo",
    last_name: "Ramatse",
    sex: "Female",
    date_of_birth: "1996-05-27",
    marital_status: "Single",
    national_id: "296052733",
    address: "Plot 8871, Tlokweng",
    phone: "+267 74 552 118",
    email: "boitumelo.ramatse@kgalagadi.co.bw",
    next_of_kin_name: "Kabo Ramatse",
    next_of_kin_address: "Tlokweng",
    next_of_kin_relationship: "Brother",
    department: "Sales",
    job_title: "Sales Representative",
    nature_of_employment: "Fixed-term",
    employment_type: "Full-time",
    commencement_date: "2022-02-01",
    probation_end_date: "2022-05-01",
    notice_period: "2 weeks",
    wage_rate: 7600,
    pay_interval: "Monthly",
    wage_components: "Basic P6,500; Commission variable; Transport P1,100",
    annual_leave_entitlement: 15,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Sunday",
    daily_hours: 8,
    weekly_hours: 40,
    night_work: false,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&crop=faces",
  },
  {
    id: "emp_4",
    organization_id: ORG_ID,
    employee_number: "KTC-004",
    first_name: "Phenyo",
    last_name: "Segale",
    sex: "Male",
    date_of_birth: "1988-05-30",
    marital_status: "Married",
    national_id: "388053044",
    address: "Plot 552, Phakalane, Gaborone",
    phone: "+267 71 990 004",
    email: "phenyo.segale@kgalagadi.co.bw",
    next_of_kin_name: "Lorato Segale",
    next_of_kin_address: "Phakalane, Gaborone",
    next_of_kin_relationship: "Spouse",
    department: "HR",
    job_title: "HR Officer",
    nature_of_employment: "Permanent",
    employment_type: "Full-time",
    commencement_date: "2018-09-10",
    probation_end_date: "2018-12-10",
    notice_period: "1 month",
    wage_rate: 11200,
    pay_interval: "Monthly",
    wage_components: "Basic P9,800; Transport allowance P1,400",
    annual_leave_entitlement: 18,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Saturday",
    daily_hours: 8,
    weekly_hours: 40,
    night_work: false,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200&h=200&fit=crop&crop=faces",
  },
  {
    id: "emp_5",
    organization_id: ORG_ID,
    employee_number: "KTC-005",
    first_name: "Keneilwe",
    last_name: "Mookianyane",
    sex: "Female",
    date_of_birth: "1992-11-03",
    marital_status: "Married",
    national_id: "292110355",
    address: "Plot 331, Mogoditshane",
    phone: "+267 73 221 909",
    email: "keneilwe.m@kgalagadi.co.bw",
    next_of_kin_name: "Tebogo Mookianyane",
    next_of_kin_address: "Mogoditshane",
    next_of_kin_relationship: "Spouse",
    department: "Operations",
    job_title: "Warehouse Clerk",
    nature_of_employment: "Permanent",
    employment_type: "Full-time",
    commencement_date: "2020-06-15",
    probation_end_date: "2020-09-15",
    notice_period: "1 month",
    wage_rate: 6800,
    pay_interval: "Monthly",
    wage_components: "Basic P5,800; Transport P1,000; Night-work allowance 5% of basic",
    annual_leave_entitlement: 15,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Sunday",
    daily_hours: 8,
    weekly_hours: 44,
    night_work: true,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop&crop=faces",
  },
  {
    id: "emp_6",
    organization_id: ORG_ID,
    employee_number: "KTC-006",
    first_name: "Leato",
    last_name: "Phiri",
    sex: "Male",
    date_of_birth: "1999-01-19",
    marital_status: "Single",
    national_id: "399011977",
    address: "Plot 12, Broadhurst, Gaborone",
    phone: "+267 75 010 233",
    email: "leato.phiri@kgalagadi.co.bw",
    next_of_kin_name: "Grace Phiri",
    next_of_kin_address: "Francistown",
    next_of_kin_relationship: "Mother",
    department: "Operations",
    job_title: "Driver",
    nature_of_employment: "Casual",
    employment_type: "Part-time",
    commencement_date: "2024-06-20",
    probation_end_date: "",
    notice_period: "1 week",
    wage_rate: 220,
    pay_interval: "Daily",
    wage_components: "Daily rate P220",
    annual_leave_entitlement: 15,
    sick_leave_entitlement: 14,
    public_holidays_entitlement: 12,
    weekly_rest_day: "Sunday",
    daily_hours: 8,
    weekly_hours: 40,
    night_work: false,
    status: "Active",
    termination_date: "",
    termination_reason: "",
    terminal_payments: "",
    avatar:
      "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&crop=faces",
  },
];

export const dashboardStats = {
  totalEmployees: 128,
  employeesDelta: 12,
  onLeaveToday: 15,
  pendingApprovals: 8,
  complianceRate: 98,
};

export const leaveChartData = [
  { month: "Jan", value: 18 },
  { month: "Feb", value: 38 },
  { month: "Mar", value: 32 },
  { month: "Apr", value: 48 },
  { month: "May", value: 43 },
  { month: "Jun", value: 58 },
  { month: "Jul", value: 52 },
  { month: "Aug", value: 67 },
  { month: "Sep", value: 63 },
  { month: "Oct", value: 74 },
];

export const departmentData = [
  { name: "Operations", value: 45, color: "#1A56DB" },
  { name: "Finance", value: 20, color: "#38BDF8" },
  { name: "Sales", value: 15, color: "#FBBF24" },
  { name: "HR", value: 10, color: "#34D399" },
  { name: "Other", value: 10, color: "#A78BFA" },
];

export const recentActivity = [
  { id: 1, type: "leave", title: "Leave request approved", person: "Keneilwe Mookianyane", time: "2m ago" },
  { id: 2, type: "document", title: "Document uploaded", person: "Onkabile Dintwe", time: "15m ago" },
  { id: 3, type: "employee", title: "New employee added", person: "Leato Phiri", time: "1h ago" },
  { id: 4, type: "payroll", title: "Payroll processed", person: "May 2024", time: "2h ago" },
];

export const upcomingBirthdays = [
  { id: 1, name: "Kabelo Morake", date: "May 22", avatar: seedEmployees[0].avatar },
  { id: 2, name: "Tshepiso Sentle", date: "May 24", avatar: seedEmployees[1].avatar },
  { id: 3, name: "Boitumelo Ramatse", date: "May 27", avatar: seedEmployees[2].avatar },
  { id: 4, name: "Phenyo Segale", date: "May 30", avatar: seedEmployees[3].avatar },
];

export const DEPARTMENTS = ["Operations", "Finance", "Sales", "HR", "Marketing", "IT", "Other"];
export const NATURE_OF_EMPLOYMENT = ["Permanent", "Fixed-term", "Casual", "Probation", "Seasonal"];
export const EMPLOYMENT_TYPES = ["Full-time", "Part-time", "Contract"];
export const PAY_INTERVALS = ["Monthly", "Fortnightly", "Weekly", "Daily", "Hourly"];
export const MARITAL_STATUS = ["Single", "Married", "Divorced", "Widowed"];
export const REST_DAYS = ["Sunday", "Saturday", "Monday", "Friday"];
export const LEAVE_TYPES = ["Annual", "Sick", "Maternity", "Paternity", "Compassionate", "Study", "Unpaid"];
